var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-session" },
    [
      !_vm.pageLoading
        ? _c(
            "div",
            [
              _vm.session
                ? _c("div", { staticClass: "bl-session-header" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-wrap items-center justify-between flex-shrink-0 h-12 px-6 lg:flex-no-wrap gap-y-2 gap-x-16 bg-pure-white",
                        attrs: { id: "session-header" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2 truncate" },
                          [
                            _c("BlBreadcrumbs", {
                              attrs: { breadcrumbs: _vm.breadcrumbs }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 h-6 gap-2 px-2 rounded-full bg-success-100"
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "w-4 h-4",
                                  class: { "animate-spin": _vm.saveLoading },
                                  attrs: { icon: "update", color: "success" }
                                }),
                                _vm._v(" "),
                                _vm.saveLoading
                                  ? _c("BlTextBody2", {
                                      staticClass: "text-success",
                                      attrs: { text: "Saving changes" }
                                    })
                                  : _c("BlTextBody2", {
                                      staticClass: "text-success",
                                      attrs: { text: "All changes saved" }
                                    })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "h-7.5 flex-grow flex-shrink-0 flex items-center justify-end gap-2"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex items-center gap-2",
                                attrs: { id: "appointment-date" }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "w-6 h-6",
                                  attrs: { icon: "calendar-blank" }
                                }),
                                _vm._v(" "),
                                _vm.sessionAppointment.timeslot
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center flex-shrink-0 h-8 px-2 truncate border rounded bg-slate-200 border-slate-200 max-w-64"
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: {
                                            text:
                                              _vm.sessionAppointment.timeslot
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex items-center gap-2",
                                attrs: { id: "appointment-supervisors" }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "w-6 h-6",
                                  attrs: { icon: "people-therapist" }
                                }),
                                _vm._v(" "),
                                !_vm.appointmentSupervisors.length
                                  ? _c(
                                      "div",
                                      { staticClass: "flex lg:block" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center flex-shrink-0 h-8 px-2 truncate border rounded bg-success-100 border-success-100 max-w-64"
                                          },
                                          [
                                            _c("BlTextBody2", {
                                              staticClass:
                                                "truncate text-success",
                                              attrs: {
                                                text: "No therapist assigned"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._l(
                                      _vm.appointmentSupervisors.slice(0, 3),
                                      function(supervisor) {
                                        return _c(
                                          "div",
                                          {
                                            key: supervisor.id,
                                            staticClass: "flex lg:block"
                                          },
                                          [
                                            supervisor.name
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center flex-shrink-0 h-8 px-2 truncate border rounded bg-success-100 border-success-100 max-w-64",
                                                    attrs: {
                                                      title: supervisor.name
                                                    }
                                                  },
                                                  [
                                                    _c("BlTextBody2", {
                                                      staticClass:
                                                        "truncate text-success",
                                                      attrs: {
                                                        text: supervisor.name
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }
                                    ),
                                _vm._v(" "),
                                _vm.appointmentSupervisors.slice(3).length
                                  ? _c("div", { staticClass: "relative" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center justify-center cursor-pointer",
                                          on: {
                                            click: function($event) {
                                              _vm.openMoreSupervisor = !_vm.openMoreSupervisor
                                            }
                                          }
                                        },
                                        [
                                          _c("BlBubbleCount", {
                                            staticClass:
                                              "h-7 hover:bg-light-purple-100",
                                            attrs: {
                                              count:
                                                "+ " +
                                                _vm.appointmentSupervisors.slice(
                                                  3
                                                ).length
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.openMoreSupervisor
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "absolute top-0 right-0 z-50 flex flex-col gap-1 p-1 mt-10 truncate border rounded bg-pure-white border-grey-200 min-w-40"
                                            },
                                            _vm._l(
                                              _vm.appointmentSupervisors.slice(
                                                3
                                              ),
                                              function(supervisor) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: supervisor.id,
                                                    staticClass: "flex max-w-64"
                                                  },
                                                  [
                                                    supervisor.name
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "px-4 py-2 text-left truncate rounded outline-none",
                                                            attrs: {
                                                              title:
                                                                supervisor.name
                                                            }
                                                          },
                                                          [
                                                            _c("BlTextBody2", {
                                                              staticClass:
                                                                "truncate text-grey",
                                                              attrs: {
                                                                text:
                                                                  supervisor.name
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.enableAppointment
                              ? _c(
                                  "div",
                                  [
                                    !_vm.sessionAppointment.user
                                      ? _c("BlInputButton", {
                                          attrs: {
                                            type: "outlined",
                                            dense: "",
                                            icon: "edit",
                                            label: "Schedule this session"
                                          },
                                          on: {
                                            clicked: function($event) {
                                              _vm.newScheduleOpened = true
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.sessionAppointment.user
                                      ? _c("BlInputButton", {
                                          attrs: {
                                            type: "outlined",
                                            dense: "",
                                            icon: "edit",
                                            label: "Edit"
                                          },
                                          on: {
                                            clicked: function($event) {
                                              _vm.editScheduleOpened = true
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "bl-session-header-detail" }, [
                      _c(
                        "div",
                        { staticClass: "bl-session-header-detail-container" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sessionName,
                                expression: "sessionName"
                              }
                            ],
                            staticClass:
                              "w-full h-10 px-4 text-2xl font-bold border rounded outline-none text-grey focus:border-light-purple",
                            style: {
                              lineHeight: "calc(11 / 7)",
                              letterSpacing: "0.5px"
                            },
                            attrs: {
                              type: "text",
                              placeholder: "Type session name"
                            },
                            domProps: { value: _vm.sessionName },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.sessionName = $event.target.value
                                },
                                _vm.onInputName
                              ]
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bl-session-header-action" },
                        [
                          _c("BlInputButton", {
                            attrs: {
                              label: "Duplicate draft from",
                              type: "plain"
                            },
                            on: {
                              clicked: function($event) {
                                _vm.duplicateSessionOpened = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: { label: "Download as PDF", type: "plain" },
                            on: {
                              clicked: function($event) {
                                _vm.downloadOpened = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputButton", {
                            attrs: {
                              label: "Start session",
                              loading: _vm.launchLoading,
                              disabled: _vm.session.status !== "draft"
                            },
                            on: { clicked: _vm.onStartSession }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("TargetJobProgression"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-shrink-0 w-full h-12 gap-4 px-6 pt-2 border-b bg-pure-white border-slate-400"
                },
                _vm._l(_vm.tabs, function(tab) {
                  return _c(
                    "router-link",
                    {
                      key: tab.target,
                      staticClass:
                        "flex items-center justify-center w-full transition-all duration-300 border-b-4",
                      class: tab.isActive
                        ? "border-light-purple"
                        : "border-pure-white",
                      attrs: { to: tab.target }
                    },
                    [
                      tab.isActive
                        ? _c("BlTextSubtitle2", { attrs: { text: tab.label } })
                        : _c("BlTextBody1", { attrs: { text: tab.label } })
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.activeTab === "targets"
                ? _c(
                    "div",
                    {
                      staticClass: "bl-session-body bg-slate-200",
                      style: { height: "calc(100vh - 15.5rem)" }
                    },
                    [
                      _c("div", { staticClass: "bl-session-targets" }, [
                        _c(
                          "div",
                          { staticClass: "bl-session-targets-header" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bl-session-targets-title-container"
                              },
                              [
                                _c("BlTextSubtitle1", {
                                  staticClass:
                                    "bl-session-targets-header-title",
                                  attrs: { text: "List of targets" }
                                }),
                                _vm._v(" "),
                                _c("BlBubbleCount", {
                                  attrs: {
                                    count: _vm.targetsFiltered.length || 0
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "bl-session-targets-header-desc",
                              attrs: {
                                text: "Here is a list of your client' targets."
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "grid items-center grid-cols-12 gap-2"
                              },
                              [
                                _c("BlSingleFilter", {
                                  class: [
                                    _vm.searchOpened
                                      ? "col-span-6"
                                      : "col-span-10"
                                  ],
                                  attrs: {
                                    label: "Status",
                                    placeholder: "By status",
                                    options: _vm.filterStatusoOtions
                                  },
                                  on: { change: _vm.onFilterStatus },
                                  model: {
                                    value: _vm.filterStatus,
                                    callback: function($$v) {
                                      _vm.filterStatus = $$v
                                    },
                                    expression: "filterStatus"
                                  }
                                }),
                                _vm._v(" "),
                                !_vm.searchOpened
                                  ? _c("BlInputButton", {
                                      staticClass:
                                        "w-full col-span-2 border-grey-200",
                                      attrs: {
                                        icon: "search",
                                        type: "outlined"
                                      },
                                      on: { clicked: _vm.searchHandler }
                                    })
                                  : _c("BlInputSearch", {
                                      staticClass: "col-span-6",
                                      attrs: { input: _vm.searchInput },
                                      on: { changed: _vm.inputHandler }
                                    })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.filterStatus.length === 1 &&
                        _vm.filterStatus.includes("mastered")
                          ? _c(
                              "div",
                              { staticClass: "flex pl-4 pr-5 lg:pl-6 lg:pr-7" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center gap-2 p-2 rounded-b bg-info-100"
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "w-5",
                                      attrs: { icon: "toast-info" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass: "text-info",
                                      attrs: {
                                        text:
                                          "Only targets with probing can be selected for the session."
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "bl-session-targets-body",
                            style: {
                              height:
                                "calc(100vh - 4.5rem - 3rem - 4.5rem - 3rem - 1.5rem - 10rem)"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sticky top-0 z-10 flex-shrink-0 py-3 h-18 bg-pure-white"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-between flex-shrink-0 h-12 gap-2 px-4 border rounded border-slate-400 bg-slate-200"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-2 truncate",
                                        attrs: {
                                          title:
                                            _vm.checkedTargetIds.length +
                                            " target(s) selected"
                                        }
                                      },
                                      [
                                        _c("BlInputCheck", {
                                          attrs: {
                                            indeterminate:
                                              _vm.checkedTargetIds.length > 0,
                                            checked:
                                              _vm.checkedTargetIds.length > 0 &&
                                              _vm.checkedTargetIds.length ===
                                                _vm.targetsFiltered.length
                                          },
                                          on: {
                                            changed: function($event) {
                                              return _vm.onCheckAllTargets()
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: {
                                            text:
                                              _vm.checkedTargetIds.length +
                                              " target(s) selected"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.checkedTargetIds.length
                                      ? _c("BlInputButton", {
                                          attrs: {
                                            label:
                                              "Add " +
                                              _vm.checkedTargetIds.length +
                                              " to session",
                                            title:
                                              "Add " +
                                              _vm.checkedTargetIds.length +
                                              " to session",
                                            icon: "plus-circle",
                                            type: "outlined",
                                            dense: "",
                                            disabled: _vm.addMeasurementLoading
                                          },
                                          on: {
                                            clicked: function($event) {
                                              return _vm.onAddCheckedTargets()
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.targetsLoading
                              ? _c(
                                  "div",
                                  { staticClass: "sticky z-20 top-18" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "absolute z-20 grid w-full opacity-75 -top-18 bg-pure-white place-items-center",
                                        style: {
                                          height:
                                            "calc(100vh - 4.5rem - 3rem - 4.5rem - 3rem - 1.5rem - 10rem)"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "blum-loader"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : !_vm.targetsFiltered.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center",
                                    style: {
                                      height:
                                        "calc(100vh - 4.5rem - 3rem - 4.5rem - 3rem - 1.5rem - 10rem - 4.5rem)"
                                    }
                                  },
                                  [
                                    _c("BlTextBody1", {
                                      attrs: { text: "Target(s) not found." }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-4" },
                                  _vm._l(_vm.targetsFiltered, function(target) {
                                    return _c(
                                      "div",
                                      {
                                        key: target.id,
                                        staticClass:
                                          "transition-all duration-300 bl-session-target cursor-grab",
                                        class: [
                                          _vm.dragId === target.id.toString()
                                            ? "opacity-0"
                                            : "opacity-100"
                                        ],
                                        attrs: { "data-id": target.id },
                                        on: {
                                          mousedown: _vm.dragStart,
                                          touchstart: _vm.dragStart
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "pointer-events-none bl-session-target-border",
                                          style: {
                                            backgroundColor:
                                              target.curriculum_color ||
                                              "#EAECF0"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "whitespace-pre-line bl-session-target-body",
                                            attrs: { title: target.description }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "bl-session-target-curriculum-container"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center gap-2 truncate",
                                                    attrs: {
                                                      title:
                                                        target.curriculum_name
                                                    }
                                                  },
                                                  [
                                                    _c("BlInputCheck", {
                                                      attrs: {
                                                        checked: _vm.checkedTargetIds.includes(
                                                          target.id
                                                        )
                                                      },
                                                      on: {
                                                        changed: function(
                                                          $event
                                                        ) {
                                                          return _vm.onToggleCheckTarget(
                                                            target.id
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("BlTextBody2", {
                                                      staticClass:
                                                        "truncate bl-session-target-curriculum",
                                                      attrs: {
                                                        text:
                                                          target.curriculum_name
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center gap-2"
                                                  },
                                                  [
                                                    _vm.checkPassedActionRecommendation(
                                                      target
                                                    ) &&
                                                    target.status !== "mastered"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "p-1 bg-orange-300",
                                                            style: {
                                                              borderRadius:
                                                                "4px"
                                                            }
                                                          },
                                                          [
                                                            _c("BlIcon", {
                                                              staticClass:
                                                                "w-4 h-4",
                                                              attrs: {
                                                                icon: "tooltip"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("StatusChip", {
                                                      attrs: {
                                                        status: target.status,
                                                        dense: ""
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("BlTextSubtitle2", {
                                              staticClass:
                                                "truncate bl-session-target-name",
                                              staticStyle: {
                                                "pointer-events": "none"
                                              },
                                              attrs: { text: target.name }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              staticClass:
                                                "whitespace-pre-line bl-session-target-desc",
                                              staticStyle: {
                                                "pointer-events": "none"
                                              },
                                              attrs: {
                                                text: target.description
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "grid grid-cols-12 gap-2"
                                              },
                                              [
                                                !_vm.measurementsFixed
                                                  ? _c("BlInputButton", {
                                                      staticClass: "col-span-6",
                                                      attrs: {
                                                        label:
                                                          "Add to fixed position",
                                                        title:
                                                          "Add to fixed position",
                                                        icon: "lock",
                                                        type: "outlined",
                                                        dense: "",
                                                        disabled:
                                                          _vm.addMeasurementLoading
                                                      },
                                                      on: {
                                                        clicked: function(
                                                          $event
                                                        ) {
                                                          return _vm.onAddMeasurement(
                                                            target.id,
                                                            true
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("BlInputButton", {
                                                  class: [
                                                    _vm.measurementsFixed
                                                      ? "col-span-12"
                                                      : "col-span-6"
                                                  ],
                                                  attrs: {
                                                    label: "Add to session",
                                                    title: "Add to session",
                                                    icon: "plus-circle",
                                                    type: "outlined",
                                                    dense: "",
                                                    disabled:
                                                      _vm.addMeasurementLoading
                                                  },
                                                  on: {
                                                    clicked: function($event) {
                                                      return _vm.onAddMeasurement(
                                                        target.id
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bl-session-measurements" },
                        [
                          _vm.measurementsFixed
                            ? _c("MeasurementCard", {
                                staticClass:
                                  "bl-session-measurement bl-session-measurements-fixed",
                                attrs: {
                                  measurement: _vm.measurementsFixed,
                                  sessionStatus: _vm.session.status
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "bl-session-measurements-fixed"
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "bl-session-measurement-icon",
                                    attrs: { icon: "lock", color: "primary" }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle2", {
                                    staticClass: "bl-session-measurement-name",
                                    attrs: { text: "Fixed position" }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "bl-session-measurement-message",
                                    attrs: {
                                      text:
                                        "Target placed here will be fixed on the top part of the page"
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bl-session-measurements-cells-container"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "bl-session-measurements-cells"
                                },
                                _vm._l(
                                  _vm.measurementsSorted.length +
                                    6 -
                                    (_vm.measurementsSorted.length % 3),
                                  function(n) {
                                    return _c("div", {
                                      key: n,
                                      staticClass: "bl-session-measurement-cell"
                                    })
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _vm.measurementsSorted.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bl-session-measurements-container"
                                    },
                                    _vm._l(_vm.measurementsSorted, function(
                                      measurement
                                    ) {
                                      return _c("MeasurementCard", {
                                        key: measurement.id,
                                        staticClass: "bl-session-measurement",
                                        attrs: {
                                          measurement: measurement,
                                          sessionStatus: _vm.session.status
                                        }
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeTab === "comments" && _vm.session
                ? _c(
                    "div",
                    {
                      staticClass:
                        "relative flex justify-center w-screen py-6 overflow-y-auto bg-slate-200",
                      style: { height: "calc(100vh - 15.5rem)" }
                    },
                    [
                      _c("SessionDraftComments", {
                        attrs: { sessionId: _vm.session.id }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dragTarget
                ? _c(
                    "div",
                    {
                      ref: "blSessionTargetDecoy",
                      staticClass: "bl-session-target-decoy",
                      style: {
                        left: _vm.dragPos.x + "px",
                        top: _vm.dragPos.y + "px",
                        width: _vm.dragPos.w + "px"
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "bl-session-target-border",
                        style: {
                          backgroundColor: _vm.dragTarget.curriculum_color,
                          pointerEvents: "none"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bl-session-target-body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bl-session-target-curriculum-container",
                              staticStyle: { "pointer-events": "none" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center gap-2 truncate"
                                },
                                [
                                  _c("BlInputCheck", {
                                    attrs: { checked: false }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "truncate bl-session-target-curriculum",
                                    attrs: {
                                      text: _vm.dragTarget.curriculum_name
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _vm.checkPassedActionRecommendation(
                                    _vm.dragTarget
                                  ) && _vm.dragTarget.status !== "mastered"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "p-1 bg-orange-300",
                                          style: { borderRadius: "4px" }
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "w-4 h-4",
                                            attrs: { icon: "tooltip" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("StatusChip", {
                                    attrs: {
                                      status: _vm.dragTarget.status,
                                      dense: ""
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("BlTextSubtitle2", {
                            staticClass: "truncate bl-session-target-name",
                            staticStyle: { "pointer-events": "none" },
                            attrs: { text: _vm.dragTarget.name }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass:
                              "whitespace-pre-line bl-session-target-desc",
                            staticStyle: { "pointer-events": "none" },
                            attrs: { text: _vm.dragTarget.description }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "grid grid-cols-12 gap-2",
                              staticStyle: { "pointer-events": "none" }
                            },
                            [
                              !_vm.measurementsFixed
                                ? _c("BlInputButton", {
                                    staticClass: "col-span-6",
                                    attrs: {
                                      label: "Add to fixed position",
                                      icon: "lock",
                                      type: "outlined",
                                      dense: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("BlInputButton", {
                                class: [
                                  _vm.measurementsFixed
                                    ? "col-span-12"
                                    : "col-span-6"
                                ],
                                attrs: {
                                  label: "Add to session",
                                  icon: "plus-circle",
                                  type: "outlined",
                                  dense: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dragMove
                ? _c("div", { staticClass: "bl-session-target-areas" }, [
                    !_vm.measurementsFixed
                      ? _c("div", {
                          staticClass: "bl-session-target-area-fixed",
                          on: {
                            mouseup: function($event) {
                              _vm.onAddMeasurement(parseInt(_vm.dragId), true)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "bl-session-target-area",
                        on: {
                          mouseup: function($event) {
                            _vm.onAddMeasurement(parseInt(_vm.dragId), false)
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "bl-session-target-area-icon",
                          attrs: { icon: "goal", color: "primary" }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle2", {
                          staticClass: "bl-session-target-area-name",
                          attrs: { text: "Drop here" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "bl-session-target-area-message",
                          attrs: {
                            text:
                              "Target placed here will be on the last postiion"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "fixed z-50 flex items-center justify-between h-16 px-6 transition-all duration-500 bg-white border rounded shadow-lg w-200 border-slate-400",
                  class: [_vm.isShowPopup ? "bottom-16" : "-bottom-16"],
                  style: {
                    left: "50%",
                    transform: "translateX(-50%)"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "plain", icon: "close" },
                        on: {
                          clicked: function($event) {
                            _vm.isShowPopup = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-slate-800",
                            attrs: { text: "Quick-add targets from" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          dense: "",
                          label: "In acquisition status",
                          loading: _vm.addMeasurementLoading
                        },
                        on: { clicked: _vm.onAddAllAcquisition }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newScheduleOpened
        ? _c("SessionNewScheduleModal", {
            attrs: { session: _vm.session },
            on: {
              "close-modal": function($event) {
                _vm.newScheduleOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editScheduleOpened
        ? _c("SessionEditScheduleModal", {
            attrs: { session: _vm.session },
            on: {
              "close-modal": function($event) {
                _vm.editScheduleOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.duplicateSessionOpened
        ? _c("DuplicateSessionModal", {
            on: {
              "close-modal": function($event) {
                _vm.duplicateSessionOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.downloadOpened
        ? _c(
            "BlBackdrop",
            {
              staticClass: "bl-session-backdrop",
              attrs: {
                title: "Download as PDF",
                description:
                  "Create an offline record of your session by generating an A4 PDF version.",
                label: "Download"
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.downloadOpened = false
                },
                "backdrop-action": _vm.downloadSession
              }
            },
            [
              _c("div", { staticClass: "px-8 bl-session-backdrop-container" }, [
                _c(
                  "div",
                  { staticClass: "bl-session-backdrop-preview-container" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Preview" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "bl-session-backdrop-preview" },
                      [
                        _c("img", {
                          staticClass: "bl-session-backdrop-preview-image",
                          attrs: {
                            src:
                              "/static/session-template-" +
                              _vm.downloadType +
                              ".png"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          attrs: {
                            text:
                              _vm.downloadType === "detailed"
                                ? "1 page can consist of up to 3 targets"
                                : "1 page can consist of up to 6 targets"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bl-session-backdrop-layout-container" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "bl-session-backdrop-layout-title",
                      attrs: { text: "Choose layout" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "bl-session-backdrop-layout",
                        class:
                          _vm.downloadType === "detailed"
                            ? "bl-session-backdrop-layout-active"
                            : "",
                        on: {
                          click: function($event) {
                            _vm.downloadType = "detailed"
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "bl-session-backdrop-layout-icon",
                          attrs: {
                            icon: "message-text",
                            color:
                              _vm.downloadType === "detailed" ? "primary" : ""
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "bl-session-backdrop-layout-name",
                          attrs: { text: "Detailed template" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          staticClass: "bl-session-backdrop-layout-description",
                          attrs: {
                            text:
                              "Keep the comment boxes for a comprehensive record-keeping experience."
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "bl-session-backdrop-layout",
                        class:
                          _vm.downloadType === "simplified"
                            ? "bl-session-backdrop-layout-active"
                            : "",
                        on: {
                          click: function($event) {
                            _vm.downloadType = "simplified"
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "bl-session-backdrop-layout-icon",
                          attrs: {
                            icon: "frame",
                            color:
                              _vm.downloadType === "simplified" ? "primary" : ""
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "bl-session-backdrop-layout-name",
                          attrs: { text: "Simplified template" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          staticClass: "bl-session-backdrop-layout-description",
                          attrs: {
                            text:
                              "Without comment boxes for a cleaner and more concise layout."
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.launchBeforeTheTimeOpened
        ? _c("LaunchBeforeTheTimeModal", {
            attrs: { sessionAppointment: _vm.sessionAppointment },
            on: {
              "close-modal": function($event) {
                _vm.launchBeforeTheTimeOpened = false
              },
              "on-submit": _vm.onLaunchSession
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d90c3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d90c3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/SessionEdit.vue
// module id = null
// module chunks = 